"use strict";var parseHTML = require("./parse-html");
var VComment = require("./VComment");
var VComponent = require("./VComponent");
var VDocumentFragment = require("./VDocumentFragment");
var VElement = require("./VElement");
var VFragment = require("./VFragment");
var VNode = require("./VNode");
var VText = require("./VText");

var specialHtmlRegexp = /[&<]/;

function virtualizeChildNodes(node, vdomParent, ownerComponent) {
  var curChild = node.firstChild;
  while (curChild) {
    vdomParent.bO_(virtualize(curChild, ownerComponent));
    curChild = curChild.nextSibling;
  }
}

function virtualize(node, ownerComponent) {
  switch (node.nodeType) {
    case 1:
      return VElement.ch_(node, virtualizeChildNodes, ownerComponent);
    case 3:
      return new VText(node.nodeValue, ownerComponent);
    case 8:
      return new VComment(node.nodeValue, ownerComponent);
    case 11:
      var vdomDocFragment = new VDocumentFragment();
      virtualizeChildNodes(node, vdomDocFragment, ownerComponent);
      return vdomDocFragment;
  }
}

function virtualizeHTML(html, ownerComponent) {
  if (!specialHtmlRegexp.test(html)) {
    return new VText(html, ownerComponent);
  }

  var vdomFragment = new VDocumentFragment();
  var curChild = parseHTML(html);
  var virtualized;

  while (curChild) {
    virtualized = virtualize(curChild, ownerComponent);
    if (virtualized) vdomFragment.bO_(virtualized);
    curChild = curChild.nextSibling;
  }

  return vdomFragment;
}

var Node_prototype = VNode.prototype;

/**
 * Shorthand method for creating and appending a Text node with a given value
 * @param  {String} value The text value for the new Text node
 */
Node_prototype.t = function (value) {
  var type = typeof value;
  var vdomNode;

  if (type !== "string") {
    if (value == null) {
      value = "";
    } else if (type === "object") {
      if (value.toHTML) {
        vdomNode = virtualizeHTML(value.toHTML());
      }
    }
  }

  this.bO_(vdomNode || new VText(value.toString()));
  return this.cg_();
};

Node_prototype.bT_ = function () {
  return this.bO_(new VDocumentFragment());
};

exports.bx_ = VComment;
exports.by_ = VDocumentFragment;
exports.bw_ = VElement;
exports.bz_ = VText;
exports.bA_ = VComponent;
exports.bB_ = VFragment;
exports.ch_ = virtualize;
exports.bC_ = virtualizeHTML;